import React from "react";

export default function Backup() {
  return (
    <svg
      width="481"
      height="481"
      viewBox="0 0 481 481"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Backup" clip-path="url(#clip0)">
        <g id="Group">
          <g id="Group_2">
            <path
              id="Vector"
              d="M152.009 192.017H136.009V208.017H152.009V192.017Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_3">
          <g id="Group_4">
            <path
              id="Vector_2"
              d="M184.009 192.017H168.009V208.017H184.009V192.017Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_5">
          <g id="Group_6">
            <path
              id="Vector_3"
              d="M326.873 336.017H368.009C372.427 336.017 376.009 332.435 376.009 328.017V304.017C433.447 304.017 480.009 257.455 480.009 200.017C480.009 142.579 433.447 96.0173 376.009 96.0173C371.38 96.0193 366.757 96.3294 362.169 96.9454C340.611 25.0274 264.833 -15.7977 192.915 5.76035C138.073 22.2003 99.408 71.2374 96.217 128.401C93.489 128.145 90.745 128.017 88.009 128.017C39.408 128.017 0.0090332 167.416 0.0090332 216.017C0.0090332 264.618 39.408 304.017 88.009 304.017H104.009V328.017C104.009 332.435 107.591 336.017 112.009 336.017H153.145C156.072 347.212 164.814 355.954 176.009 358.881V416.017H96.009V432.017H176.009V464.017H96.009V480.017H184.009C188.427 480.017 192.009 476.435 192.009 472.017V358.881C203.204 355.954 211.946 347.212 214.873 336.017H265.145C268.072 347.212 276.814 355.954 288.009 358.881V472.017C288.009 476.435 291.591 480.017 296.009 480.017H384.009V464.017H304.009V432.017H384.009V416.017H304.009V358.881C315.203 355.954 323.946 347.212 326.873 336.017ZM104.009 264.017V288.017H88.009C48.244 288.017 16.009 255.781 16.009 216.017C16.009 176.252 48.244 144.017 88.009 144.017C92.878 144.021 97.734 144.511 102.505 145.481C104.877 145.945 107.332 145.326 109.201 143.793C111.063 142.247 112.125 139.941 112.089 137.521C112.089 137.361 112.017 136.177 112.009 136.017C111.965 69.7784 165.626 16.0453 231.865 16.0013C287.339 15.9643 335.599 53.9754 348.561 107.913C349.569 112.118 353.735 114.761 357.969 113.881C405.541 103.931 452.171 134.429 462.121 182.001C472.071 229.573 441.573 276.203 394.001 286.153C388.083 287.391 382.054 288.015 376.008 288.017V264.017C376.008 259.599 372.426 256.017 368.008 256.017H352.008V240.017H368.008C372.426 240.017 376.008 236.435 376.008 232.017V168.017C376.008 163.599 372.426 160.017 368.008 160.017H112.008C107.59 160.017 104.008 163.599 104.008 168.017V232.017C104.008 236.435 107.59 240.017 112.008 240.017H128.008V256.017H112.008C107.59 256.017 104.009 259.599 104.009 264.017ZM120.009 224.017V176.017H360.009V224.017H120.009ZM336.009 240.017V256.017H144.009V240.017H336.009ZM184.009 344.017C175.172 344.017 168.009 336.854 168.009 328.017C168.009 319.18 175.172 312.017 184.009 312.017C192.846 312.017 200.009 319.18 200.009 328.017C200.009 336.854 192.845 344.017 184.009 344.017ZM265.145 320.017H214.873C210.534 302.971 193.199 292.67 176.154 297.008C164.85 299.885 156.023 308.712 153.145 320.017H120.009V272.017H360.009V320.017H326.873C322.535 302.971 305.199 292.67 288.154 297.008C276.849 299.886 268.022 308.713 265.145 320.017ZM296.009 344.017C287.172 344.017 280.009 336.854 280.009 328.017C280.009 319.18 287.172 312.017 296.009 312.017C304.846 312.017 312.009 319.18 312.009 328.017C312.009 336.854 304.845 344.017 296.009 344.017Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_7">
          <g id="Group_8">
            <path
              id="Vector_4"
              d="M80.009 464.017H64.009V480.017H80.009V464.017Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_9">
          <g id="Group_10">
            <path
              id="Vector_5"
              d="M48.009 464.017H32.009V480.017H48.009V464.017Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_11">
          <g id="Group_12">
            <path
              id="Vector_6"
              d="M16.009 464.017H0.0090332V480.017H16.009V464.017Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_13">
          <g id="Group_14">
            <path
              id="Vector_7"
              d="M80.009 416.017H64.009V432.017H80.009V416.017Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_15">
          <g id="Group_16">
            <path
              id="Vector_8"
              d="M48.009 416.017H32.009V432.017H48.009V416.017Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_17">
          <g id="Group_18">
            <path
              id="Vector_9"
              d="M16.009 416.017H0.0090332V432.017H16.009V416.017Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_19">
          <g id="Group_20">
            <path
              id="Vector_10"
              d="M416.009 464.017H400.009V480.017H416.009V464.017Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_21">
          <g id="Group_22">
            <path
              id="Vector_11"
              d="M448.009 464.017H432.009V480.017H448.009V464.017Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_23">
          <g id="Group_24">
            <path
              id="Vector_12"
              d="M480.009 464.017H464.009V480.017H480.009V464.017Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_25">
          <g id="Group_26">
            <path
              id="Vector_13"
              d="M416.009 416.017H400.009V432.017H416.009V416.017Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_27">
          <g id="Group_28">
            <path
              id="Vector_14"
              d="M448.009 416.017H432.009V432.017H448.009V416.017Z"
              fill="#242424"
            />
          </g>
        </g>
        <g id="Group_29">
          <g id="Group_30">
            <path
              id="Vector_15"
              d="M480.009 416.017H464.009V432.017H480.009V416.017Z"
              fill="#242424"
            />
          </g>
        </g>
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="480.017" height="480.017" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
